import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["template", "container"]

  add(event) {
    event.preventDefault()
    const content = this.templateTarget.content.cloneNode(true)
    const timestamp = new Date().getTime()
    
    content.querySelectorAll('[name*="NEW_RECORD"]').forEach(element => {
      element.name = element.name.replace('NEW_RECORD', timestamp)
    })
    
    this.containerTarget.insertBefore(content, this.containerTarget.firstChild)
    
    // Initialize TomSelect for the new tag field
    const newSelect = this.containerTarget.querySelector(`[name*="${timestamp}"][data-controller="tags"]`)
    if (newSelect) {
      const controller = this.application.getControllerForElementAndIdentifier(newSelect, 'tags')
      if (controller) controller.connect()
    }
  }

  remove(event) {
    event.preventDefault()
    const button = event.currentTarget
    const wrapper = button.closest('.nested-fields')
    const destroyInput = wrapper.querySelector('input[name*="_destroy"]')
    
    if (destroyInput) {
      destroyInput.value = '1'
      wrapper.style.display = 'none'
    }
  }
} 